module.exports = __webpack_public_path__ + "06_medium_brown.8107b2c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_medium_brown.png
// module id = qOBq
// module chunks = 0